import { useEffect, useState } from "react";
import { useConditional } from "../../core/hooks/useConditional";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { Icon } from "../../core/ui/icons";
import { first, last } from "../../core/utils/array";
import { DateCol, GenericCol, ShareCountCol } from "../../layout/TableCells";
import { Address, AddressType, CompanyOfficer, getAddressTypeName, ShareHolder } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { parseTrackedItems } from "./parseTrackedItem";
import { api } from "../../api/api";
import { expectArray } from "rant-utils";
import { FormatCustomScriptFunctions } from "../../data-entry/runScript";



export function CompanyShareholders(props: {
	shareholders: ShareHolder[],
}) {


	const [entityMap, setEntityMap] = useState(null);

	useEffect(() => {
		const ids = [];
		for(let s of props.shareholders) {
			if (ids.indexOf(s.entity) < 0) ids.push(s.entity);
		}

		api.entity_get_specific({
			ids,
		}).then((items) => {
			const arr = expectArray(items);
			const map = {} as any;
			for(let i of arr) {
				map[i.id] = i;
			}

			// grab all of the entity names
			for(let s of props.shareholders) {
				const e = map[s.entity];
				if (!e) continue;

				s.entityName = e.title;
			}

			setEntityMap(map);

		}).catch(() => {

		});

	}, []);







// 	const items = [];

// 	// organise the data first
// 	// want it grouped by: entity, position, history

// 	const entities = {} as any;
// 	const sortedEntities = [];
// debugger;
// 	if (props.shareholders) {
// 		for(let s of props.shareholders) {
// 			if (!entities[s.entity]) {
// 				const tmp = {} as any;
// 				entities[s.entity] = tmp;
// 				sortedEntities.push(tmp);
// 			}

// 			const ent = entities[s.entity];

// 			if (!ent[s.shareClass]) {
// 				ent[s.shareClass] = [] as CompanyOfficer[];
// 			}
// 			ent[s.shareClass].push(s);
// 		}

// 		// sortedEntities.sort((a, b) => {
// 		// 	let result = 0;
// 		// 	result = a.
// 		// 	return a.name.localCompare. 
// 		// });
// 	}

	const classes = {} as any;
	const sortedClasses = [] as any[];
	//debugger;
	if (props.shareholders) {
		for(let s of props.shareholders) {
			if (!classes[s.shareClass]) {
				const c = {
					shareClass: s.shareClass,
					items: [] as any[],
				};
				classes[s.shareClass] = c;
				sortedClasses.push(c);
			}

			classes[s.shareClass].items.push(s);
		}
	}

	let items = [];
	for(let c of sortedClasses) {
		const rows = classes[c.shareClass].items;

		items.push(
			<div className="margin-bottom-10">
				<h3>{c.shareClass}</h3>
				<Table
					cols={[
						GenericCol("Shareholder", "entityName"),
						ShareCountCol(),
						DateCol("Effective", "effective"),

					]}
					items={rows}
				/>
			</div>
		)
	}

	return (
		<div>
			{items}
		</div>
	);
}

//function 